module.exports = __webpack_public_path__ + "static/weronikawork1-4a269e2154b4078baa5de282bd8b1ea7.jpg";